module.exports = __webpack_public_path__ + "img/public-praise.4f1189e4.png";